import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isString, isObject } from 'lodash';

import Fa from 'react-fontawesome';
import Shimmer from '../shimmer';
import styles from './styles.css';
import Avatar from '../avatar';

const roles = {
  superadmin: 'Super Admin',
  admin: 'Admin',
  pi: 'TruVoice by Corporate Visions',
  user: 'Standard User',
};

class OwnerCell extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      owner,
      isShimmer,
      showEmail,
      clickableFullEmail,
      showPhone,
      showFullEmail,
      detailUrl,
      isTooltip,
      fixWidth,
    } = this.props;

    if (!owner) {
      return null;
    }
    const name =
      owner.name ||
      owner.display_name ||
      owner.first_name + ' ' + owner.last_name;
    if (isShimmer) {
      return (
        <div>
          <Shimmer value={name} />
        </div>
      );
    }
    const phone = owner.phone || owner.mobile_phone || null;
    const isHashed = owner.is_hashed || owner.is_gdpr_hashed;
    const sfRole = owner.role && isObject(owner.role) ? owner.role : null;
    const role = owner.role && isString(owner.role) ? roles[owner.role] : null;

    return (
      <div
        className={`${styles.ownerCell} ${
          fixWidth ? styles.maxWidth : ''
        } media`}>
        <div className={`${styles.mediaContainer} media-left`}>
          <Avatar user={owner} isTooltip={isTooltip} />
          {isHashed && <Fa name='lock' className={styles.userHashed} />}
          {owner.is_none_standard_user === true && (
            <Fa name='bolt' className={`${styles.isNsfUser}`} />
          )}
        </div>
        <div className='media-body'>
          <h4 className={`${styles.mediaHeading} media-heading`}>
            {!isHashed &&
              showEmail &&
              !showFullEmail &&
              owner.email &&
              owner.email.length > 0 && (
                <span className={styles.emailIcon}>
                  <a href={`mailto:${owner.email}`}>
                    <Fa name='envelope-o' />
                  </a>
                  &nbsp;
                </span>
              )}
            {!detailUrl && <span className={styles.userName}>{name}</span>}
            {detailUrl && (
              <Link to={detailUrl} className={styles.userName}>
                {name}
              </Link>
            )}
          </h4>
          {role !== null && (
            <div>
              <span className='badge'>{role}</span>
            </div>
          )}
          {sfRole !== null && sfRole.name && (
            <div className={`${styles.userRole} text-muted`}>
              <Fa name='tag' /> {sfRole.name}
            </div>
          )}
          {(isHashed || showFullEmail) &&
            showEmail &&
            owner.email &&
            owner.email.length > 0 && (
              <div
                title={owner.email}
                className={`${styles.userEmail1} text-muted`}>
                {!clickableFullEmail && (
                  <span>
                    <Fa name='envelope' />
                    &nbsp;{owner.email}
                  </span>
                )}
                {clickableFullEmail && (
                  <a href={`mailto:${owner.email}`}>
                    <Fa name='envelope' />
                    &nbsp;{owner.email}
                  </a>
                )}
              </div>
            )}
          {showPhone && phone !== null && (
            <div title={phone} className={`${styles.userPhone} text-muted`}>
              {!isHashed && (
                <span>
                  <Fa name='phone' /> {phone}
                </span>
              )}
              {isHashed && <span>{phone}</span>}
            </div>
          )}
        </div>
      </div>
    );
  }
}

OwnerCell.propTypes = {
  owner: PropTypes.shape({
    email: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    display_name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    phone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  isShimmer: PropTypes.bool,
  showEmail: PropTypes.bool,
  showFullEmail: PropTypes.bool,
  showPhone: PropTypes.bool,
  detailUrl: PropTypes.string,
  isTooltip: PropTypes.bool,
  clickableFullEmail: PropTypes.bool,
  fixWidth: PropTypes.bool,
};
OwnerCell.defaultProps = {
  isShimmer: false,
  showEmail: true,
  detailUrl: null,
  showFullEmail: false,
  showPhone: true,
  clickableFullEmail: false,
  isTooltip: false,
  fixWidth: true,
};
OwnerCell.contextTypes = {
  store: PropTypes.shape({}),
};

export default OwnerCell;
